import { toast } from 'sonner'
import { apiErrors, useMarkPurchaseOrdersReviewed } from './api'

/**
 * Marking POs reviewed from anywhere on the project page. Reviewed means ready to send: once every
 * PO is reviewed they all go to their manufacturers, with no separate send step (USA-1333).
 */
export function usePoReviewMarks(projectUuid: string) {
  const mark = useMarkPurchaseOrdersReviewed(projectUuid)

  function request(uuids: string[], reviewed: boolean, onDone?: () => void) {
    mark.mutate(
      { uuids, reviewed },
      {
        onSuccess: (review) => {
          onDone?.()
          if (review.state === 'placed') toast.success('All POs reviewed and sent to the manufacturers')
        },
        onError: (error) => toast.error(apiErrors(error, 'The review was not saved. Try again.')[0]),
      },
    )
  }

  return {
    request,
    marking: mark.isPending,
    markingUuids: mark.isPending ? (mark.variables?.uuids ?? []) : [],
  }
}
